







































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

const userManager = namespace("userManager");
@Component({})
export default class add extends Vue {
  dialogVisible: boolean = false;
  loading: boolean = false;
  @Prop() editData: any = null;
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;
  ruleForm: any = {
    account: "",
    lastName: "",
    firstName: "",
    mobile: "",
    getPassword: null,
    email: ""
  };
  rules: any = {
    account: [
      {
        required: true,
        message: "账号不能为空"
      },
      { pattern: /^[^\u4e00-\u9fa5]*$/, message: "账号不能输入中文" }
    ],
    lastName: [
      {
        required: true,
        message: "名字不能为空"
      }
    ],
    mobile: [
      {
        required: true,
        message: "手机号不能为空"
      },
      {
        pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
        message: "请输入正确的手机号码"
      }
    ],
    email: [
      {
        required: true,
        message: "邮箱不能为空"
      },
      {
        type: "email",
        message: "请输入正确的邮箱地址"
      }
    ],
    getPassword: [
      {
        required: true,
        message: "请选择找回密码方式"
      }
    ]
  };
  @userManager.Action addUser;
  @userManager.Action updateStaffAccount;
  created() {
    this.editData && this.setData();
  }
  @Watch("dialogVisible")
  onEditDataChange(val) {
    this.$nextTick(() => {
      (this as any).$refs.form.resetFields();
      this.setData();
    });
  }
  setData() {
    let {
      userCode,
      account = "",
      lastName = "",
      firstName = "",
      mobile = "",
      email = ""
    } = this.editData || {};
    this.ruleForm = {
      userCode,
      account,
      lastName,
      firstName,
      mobile,
      email
    };
  }

  async handleSubmit() {
    const $form: any = this.$refs["form"];
    $form.validate(async valid => {
      if (valid) {
        let {
          userCode,
          account = "",
          lastName = "",
          firstName = "",
          mobile = "",
          email = ""
        } = this.ruleForm;
        this.loading = true;
        if (this.isEdit) {
          try {
            await this.updateStaffAccount({
              input: {
                userCode,
                account,
                lastName,
                firstName,
                mobile,
                email
              }
            })
              .then(_ => {
                this.$emit("refresh", 1);
                this.dialogVisible = false;
                this.$message({ type: "success", message: "编辑成功" });
                (this as any).$refs.form.resetFields();
              })
              .finally(_ => {
                this.loading = false;
              });
          } catch (error) {
            console.log(error);
          }
        } else {
          try {
            let params = {
              account,
              lastName,
              firstName
            };
            await this.addUser({
              input:
                this.ruleForm.getPassword === 1
                  ? { ...params, mobile, isSendMail: 1 }
                  : { ...params, email, isSendMail: 1 }
            })
              .then(_ => {
                this.$emit("refresh", 0);
                this.dialogVisible = false;
                this.$message({ type: "success", message: "新增成功" });
                (this as any).$refs.form.resetFields();
              })
              .finally(_ => {
                this.loading = false;
              });
          } catch (error) {
            console.log(error);
          }
        }
      }
    });
  }
}
